import { maturityStyle } from '@/lib/format';

interface MaturityBadgeProps {
  level: string;
  className?: string;
}

export function MaturityBadge({ level, className = '' }: MaturityBadgeProps) {
  const style = maturityStyle(level);

  return (
    <span
      className={`text-[0.62rem] font-bold uppercase tracking-wider px-2.5 py-0.5 rounded-full border ${className}`}
      style={{ background: style.bg, color: style.text, borderColor: style.border }}
    >
      {level}
    </span>
  );
}
